import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Quiet in-app footer, rendered only inside `ProtectedLayout`.
 *
 * Its placement is the access control: because it lives behind
 * `ProtectedRoute`, the Terms link it carries never renders for an
 * unauthenticated visitor. The public marketing footer on the homepage is a
 * separate element and deliberately does not link here.
 */
const AppFooter: React.FC = () => (
  <footer
    className="border-t border-stone-200 bg-navy-050"
    style={{ paddingTop: 20, paddingBottom: 20 }}
  >
    <div className="container-content flex flex-col sm:flex-row items-center justify-between gap-3">
      <span className="font-sans text-ink-500" style={{ fontSize: 12 }}>
        &copy; {new Date().getFullYear()} Integrity Quantitative Advisors, LLC
      </span>
      <Link
        to="/terms"
        className="font-sans text-ink-500 no-underline hover:text-navy-700 hover:underline transition-colors"
        style={{ fontSize: 12 }}
      >
        Terms of Service
      </Link>
    </div>
  </footer>
);

export default AppFooter;
